import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import TheatreSidebar from "../Layouts/TheatreSidebar";

import axios from "axios";
import $ from "jquery";

export class OperatingDelivery extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      name: localStorage.getItem("currentVisitName"),
      fileNo: "",
      department: "",
      bedNo: "",
      diagnosisofAdmission: "",
      datetimeofSurgery: "",
      diagnosisofSurgery: "",
      postoperativeDiagnosis: "",
      surgeonName: "",
      assistantName: "",
      typeoftheAnaesthesia: "",
      anaesthetistName: "",
      optheatreprocedureReports: "",
      myParentTrigger: "",
      tablevaluesglobal: {},
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();

    // console.log(finalpayload);
    this.setState({
      loading:true
    })
    axios
      .post(this.api_url+"optheatre/delivery", this.state, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);
        this.setState({
          loading:false
        })
        if (response.data["status"]) {
          $(".alert-success").show();
          //
          setTimeout(function () {
            window.location.href = "/theatre/post/prelimanry";
            // window.location.href = '/physical/examination/inspection'
          }, 500);
        }
      })
      .catch((error) => {
        this.setState({
          loading:false
        })
        $("#SubmitSuccess").hide();
        $("#SubmitError").show();
        console.log(error);
      });
  };

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const {
      name,
      fileNo,
      department,
      bedNo,
      diagnosisofAdmission,
      datetimeofSurgery,
      diagnosisofSurgery,
      postoperativeDiagnosis,
      surgeonName,
      assistantName,
      typeoftheAnaesthesia,
      anaesthetistName,
      optheatreprocedureReports,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <TheatreSidebar />

        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Operating Delivery
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={name}
                      name="name"
                      readOnly
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      File No
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={fileNo}
                      name="fileNo"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Bed No
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={bedNo}
                      name="bedNo"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Diagnosis of Admission
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={diagnosisofAdmission}
                      name="diagnosisofAdmission"
                      type="text"
                      required
                    ></textarea>
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Date And Time of Surgery{" "}
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={datetimeofSurgery}
                      name="datetimeofSurgery"
                      type="datetime-local"/>
                    
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Diagnosis of Surgery
                    </h6>
                    <textarea className="form-control"
                      onChange={this.handleChange}
                      
                      name="diagnosisofSurgery">{diagnosisofSurgery}</textarea>
                   
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Post-operative Diagnosis
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={postoperativeDiagnosis}
                      name="postoperativeDiagnosis"
                      type="text"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Surgeon Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={surgeonName}
                      name="surgeonName"
                      type="text"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Assistant Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={assistantName}
                      name="assistantName"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Type of the Anaesthesia
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={typeoftheAnaesthesia}
                      name="typeoftheAnaesthesia"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Anaesthetist Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={anaesthetistName}
                      name="anaesthetistName"
                      type="text"
                      required
                    />
                  </div>

                  <div className="py-1" style={width100}>
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      optheatre procedure Reports
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={optheatreprocedureReports}
                      name="optheatreprocedureReports"
                      type="text"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved
                Successfully.
              </div>
              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                   {loading ? 'Loading' :'Submit'} 
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default OperatingDelivery;
